import { useEffect, useState } from 'react';
import type { ActivityItem } from '@/domain/audit/activity-projection';
import { listActivity } from './api/activity-api';

export function RecentActivity() {
  const [items, setItems] = useState<ActivityItem[]>([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    void listActivity(10)
      .then((response) => setItems(response.items))
      .catch(() => setFailed(true));
  }, []);

  return (
    <section aria-labelledby="recent-activity-title" className="mt-8 border-t border-border-subtle pt-6">
      <h2 id="recent-activity-title" className="mb-3 text-sm font-semibold text-text-primary">Atividade recente</h2>
      {failed ? <p className="text-sm text-text-muted">A atividade está temporariamente indisponível.</p> : items.length === 0 ? <p className="text-sm text-text-muted">Ainda não há atividade.</p> : (
        <ol className="space-y-2">
          {items.map((item) => (
            <li key={item.id} className="flex justify-between gap-4 text-sm">
              <span className="text-text-secondary">{item.title}{item.description ? ` · ${item.description}` : ''}</span>
              <time className="shrink-0 text-xs text-text-muted" dateTime={item.createdAt}>{new Date(item.createdAt).toLocaleString('pt-BR')}</time>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
